import { useState } from "react";
import { TENANT_DOMAIN } from "../../../utils/domain";
import { ERROR_MESSAGES } from "../../../constant/constant";
import { useAxios } from "../../../utils/useAxios";

/**
 * Custom hook to delete the student by the student id
 */
export const useDeleteStudent = () => {
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");
  const [success, setSuccess] = useState(false);
  const { axiosInstance } = useAxios();

  /**
   * @param {string} studentId
   * @param {()=> void} [onSuccess]
   */
  const deleteStudent = async (studentId, onSuccess) => {
    setSuccess(false);
    setError("");
    setLoading(true);
    try {
      await axiosInstance.delete(
        `${TENANT_DOMAIN}/student/destroy/${studentId}`,
      );
      setSuccess(true);
      if (onSuccess) {
        onSuccess();
      }
    } catch (error) {
      if (error.status === 500) {
        setError(ERROR_MESSAGES.INTERNAL_SERVER);
      } else {
        setError(error?.response?.data?.message || ERROR_MESSAGES.UNKNOWN);
      }
    } finally {
      setLoading(false);
    }
  };

  const resetState = () => {
    setError("");
    setSuccess(false);
  };

  return { deleteStudent, loading, error, success, resetState };
};
